import React from 'react';
import { useSearchParams } from 'react-router-dom';
import CardContainerForLuxury from '../../Components/CardContainerForLuxury/CardContainerForLuxury';
import FilterView from '../../Components/FilterView/FilterView';
import {
  getFiltersFromSearchParams,
  filtersToSearchParams,
} from '../../utils/propertyCatalogFilters';
import style from './Luxury.module.css'

const Luxury = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const filtersFromURL = getFiltersFromSearchParams(searchParams);
  const page = parseInt(searchParams.get('page'), 10) || 1;

  const handleFilterChange = (filters) => {
    setSearchParams(filtersToSearchParams(filters, { page: 1 }));
  };

  return (
    <div className={style.container}>
      {/* Luxury siempre opera en USD: se oculta el selector de moneda */}
      <FilterView
        onFilterChange={handleFilterChange}
        initialFilters={filtersFromURL}
        showCurrency={false}
      />
      <CardContainerForLuxury filters={{ ...filtersFromURL, page }} />
    </div>
  );
};

export default Luxury;
